const labels = {
  QrCode: {
    'Ref: Page title': 'MyBus',
    'Ref: Hi': 'สวัสดี',
    'Ref: Page content body': 'เมื่อมาถึงและออกเดินทางโปรดอย่าลืมสแกนบัสรหัส QR ของคุณ',
  },
};
export default labels;
